module.exports = __webpack_public_path__ + "static/media/035.464d03c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/035.jpg
// module id = 381
// module chunks = 0